import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { DataRoomRFI } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { useTranslation } from 'react-i18next';
import {
  getIsRfiStatusClosed,
  getIsRfiStatusPending,
} from 'router/subrouters/DataRoom/utils';
import { Button } from 'ncoded-component-library';
import RfiStatusTag from '../../../../../RfiStatusTag';
import useRfiChangeStatus from 'router/subrouters/DataRoom/hooks/useRfiChangeStatus';
import { generateDaysLeftString } from 'router/subrouters/Dash/subrouters/private/subrouters/AdminDashboard/pages/ListingMetrics/data';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

import './RfiAnalyticsInstance.styles.scss';

type RfiAnalyticsInstanceProps = {
  className?: string;
  rfi: DataRoomRFI;
  onClick: (id: string) => void;
};

const RfiAnalyticsInstance: React.FC<RfiAnalyticsInstanceProps> = (props) => {
  const { className, rfi, onClick } = props;

  const { _id, name, status, dataRoomRFICategories, numberOfViews, dueDate } =
    rfi;

  const { updateRfi } = useContext(RfiContext);
  const { doesntHaveAccess } = useContext(DataRoomContext);

  const canSeeMore = !getIsRfiStatusPending(status);

  const isRfiClosed = getIsRfiStatusClosed(status);

  const classes = classNames(
    'rfi-analytics-instance',
    'grid',
    { clickable: canSeeMore },
    className,
  );

  const { t } = useTranslation();

  const { changeStatus, loading } = useRfiChangeStatus(rfi, updateRfi);

  const numberOfUploadedFiles = useMemo(
    () =>
      dataRoomRFICategories.reduce(
        (acc, category) => acc + (category.files?.length || 0),
        0,
      ),
    [dataRoomRFICategories],
  );

  return (
    <div
      className={classes}
      onClick={() => {
        if (canSeeMore) onClick(_id);
      }}
    >
      <p>{name}</p>

      <RfiStatusTag status={status} />

      <p className="categories">{dataRoomRFICategories.length - 1}</p>

      <p className="uploaded-files">{numberOfUploadedFiles}</p>

      <p>{isRfiClosed ? t('closed') : generateDaysLeftString(dueDate)}</p>

      <p>{numberOfViews || 0}</p>

      {!doesntHaveAccess && (
        <Button
          disabled={loading}
          className={classNames({ alert: !isRfiClosed })}
          onClick={(e) => {
            e.stopPropagation();
            changeStatus();
          }}
        >
          {t(isRfiClosed ? 'reopen' : 'close')}
        </Button>
      )}
    </div>
  );
};

export default RfiAnalyticsInstance;
